module.exports = __webpack_public_path__ + "assets/photos/memories/frame-7--f8136017f8122ac851ec89d569b31b13.jpg";